import { AppDispatch } from '..';
import {
  failedFetchingOrderInfo,
  IOrderInfoBody,
  setOrderInfo,
  startFetchingOrderInfo,
} from '../reducers/orderInfoReducer';
import httpService from 'src/services/HttpService';

export const getOrderInfoAction = () => {
  return (dispatch: AppDispatch) => {
    dispatch(startFetchingOrderInfo());
    return httpService
      .get('purchase/params/indoor_greenhouse')
      .then((res) => {
        dispatch(setOrderInfo(res.body as unknown as IOrderInfoBody));
      })
      .catch(() => {
        dispatch(failedFetchingOrderInfo());
      });
  };
};
